export default {"src":"/evde-internet/_next/static/media/autologinImg.0dc4b3fd.svg","height":258,"width":380};